<!-- 每日发运动态实时监控 -->
<template>
  <div>
    <div ref="extraAboveCrud">
      <matrix-statistics span="8" :list="statisticsList"></matrix-statistics>
      <div class="dm-section-head">
        <p>地磅实时数据</p>
      </div>
    </div>
    <avue-crud ref="crud" :data="data" :option="option" :page.sync="page" class="penetrate">
      <template slot-scope="scope" slot="name2">
        <matrix-tag v-if="scope.row.name2 == 0" color="#15803D" text="使用中"></matrix-tag>
        <matrix-tag v-if="scope.row.name2 == 1" color="#374151" text="空闲"></matrix-tag>
        <matrix-tag v-if="scope.row.name2 == 2" color="#A16207" text="维护中"></matrix-tag>
      </template>
    </avue-crud>
    <div class="dm-section-head dm-section-head--gap">
      <p>过车明细</p>
    </div>
    <avue-crud :data="data1" :option="option1" :page.sync="page" class="penetrate">
    </avue-crud>
    <div style="height: 80px;"></div>
  </div>
</template>

<script>
import matrixStatistics from '@/components/matrix/matrix-statistics'
import matrixTag from '@/components/matrix/matrix-tag'
import crudMixins from '@/mixins/crud-mixins'

export default {
  name: 'store-management-day-dynamic-monitoring',
  mixins: [crudMixins],
  components: {
    matrixStatistics,
    matrixTag
  },
  data() {
    return {
      statisticsList: [{
        label: '今日发运总量',
        value: 128560,
        unit: '吨',
        icon: 'el-icon-s-order',
        iconColor: '#2563EB',
        tip: '同比昨日',
        subhead: '12.5%',
        compareColor: '#22C55E',
        compare: 1
      }, {
        label: '今日车辆总数',
        value: 2845,
        unit: '辆',
        icon: 'el-icon-s-data',
        iconColor: '#2563EB',
        tip: '同比昨日',
        subhead: '8.3%',
        compareColor: '#22C55E',
        compare: 1
      }, {
        label: '计划完成率',
        value: 85.6,
        unit: '%',
        icon: 'el-icon-s-marketing',
        iconColor: '#2563EB',
        tip: '同比昨日',
        subhead: '2.5%',
        compareColor: '#22C55E',
        compare: 1
      }],
      value1: '',
      input: '',
      page: {
        pageSize: 10, // 每页显示10条
        currentPage: 1, // 第一页
        total: 3 // 总条数
      },
      data: [{
        name1: '东区地磅 #1',
        name2: 0,
        name3: '458 辆',
        name4: '冀A·12345',
        name5: '2024-01-18 14:32:45',
      }, {
        name1: '东区地磅 #2',
        name2: 1,
        name3: '458 辆',
        name4: '冀A·12345',
        name5: '2024-01-18 14:32:45',
      }, {
        name1: '东区地磅 #3',
        name2: 2,
        name3: '458 辆',
        name4: '-',
        name5: '2024-01-18 14:32:45',
      }],
      option: {
        header: false,
        editBtn: false,
        delBtn: false,
        menu: false,
        menuWidth: '120px',
        height: '370px',
        searchLabelWidth: 0,
        column: [{
          prop: 'name',
          align: 'center',
          search: true,
          searchLabel: '',
          placeholder: '请输入货主',
          hide: true,
        }, {
          label: '地磅位置',
          prop: 'name1',
          align: 'center',
        }, {
          label: '状态',
          prop: 'name2',
          align: 'center',
          width: 80,

        }, {
          label: '今日累计',
          prop: 'name3',
          align: 'center'
        }, {
          label: '当前车辆',
          prop: 'name4',
          align: 'center'
        }, {
          label: '最新过磅时间',
          prop: 'name5',
          align: 'center'
        }]
      },

      data1: [{
        name1: '冀A·12345',
        name2: '河北能源集团',
        name3: '动力煤',
        name4: '2024-01-18 14:15:23',
        name5: '2024-01-18 14:32:45',
        name6: 15.65,
        name7: 55.85,
        name8: 40.20
      }, {
        name1: '冀A·12345',
        name2: '河北能源集团',
        name3: '动力煤',
        name4: '2024-01-18 14:15:23',
        name5: '2024-01-18 14:32:45',
        name6: 15.65,
        name7: 55.85,
        name8: 40.20
      }, {
        name1: '冀A·12345',
        name2: '河北能源集团',
        name3: '动力煤',
        name4: '2024-01-18 14:15:23',
        name5: '2024-01-18 14:32:45',
        name6: 15.65,
        name7: 55.85,
        name8: 40.20
      }],
      option1: {
        header: false,
        editBtn: false,
        delBtn: false,
        menu: false,
        menuWidth: '120px',
        height: '370px',
        searchLabelWidth: 0,
        searchMenuSpan: 12,
        searchMenuPosition: 'right',
        column: [{
          label: '车牌号',
          prop: 'name1',
          align: 'center',
           search: true,
          searchLabel: '',
          placeholder: '请输入货主',
        }, {
          label: '客户',
          prop: 'name2',
          align: 'center',
          width: 150,
           search: true,
          searchLabel: '',
          placeholder: '请输入货主',
        }, {
          label: '物资',
          prop: 'name3',
          align: 'center'
        }, {
          label: '空车时间',
          prop: 'name4',
          align: 'center',
          width: 170,
        }, {
          label: '重车时间',
          prop: 'name5',
          align: 'center',
          width: 170,
        }, {
          label: '皮重(吨)',
          prop: 'name6',
          align: 'center'
        }, {
          label: '毛重(吨)',
          prop: 'name7',
          align: 'center'
        }, {
          label: '净重(吨)',
          prop: 'name8',
          align: 'center'
        }]
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.crud && this.$refs.crud.getTableHeight()
      this.$refs.crud && this.$refs.crud.doLayout()
    })
  },
  methods: {
    getCrudExtraTopHeight () {
      const el = this.$refs.extraAboveCrud
      if (!el) return 0
      return el.offsetHeight + 12
    },
  }
}
</script>
<style scoped lang="scss">
.dm-section-head {
  margin-bottom: 10px;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

.dm-section-head--gap {
  margin-top: 20px;
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
